module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', {
    staticStyle: {
      "padding-top": "35px !important",
      "padding-bottom": "35px !important"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.regionChildren != null) ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), (_vm.regionChildren != null) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "search": _vm.search,
      "headers": _vm.headers,
      "items": _vm.regionChildren,
      "item-key": "name",
      "expand": "",
      "rows-per-page-items": [10, 20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('td', {
          staticClass: "text-xs-right"
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewChildren(props.item.name, props.item.id, props.item.type)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("extension")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('td', {
          staticClass: "text-xs-right"
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditRegion(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('td', {
          staticClass: "text-xs-right"
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteRegion(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]) : _vm._e()])]
      }
    }], null, false, 3450129036)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), (_vm.regionChildren == null) ? _c('p', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('strong', [_vm._v("No sub regions could be found")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}